///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2016 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0, new-cap:0,prefer-arrow-callback:0,comma-dangle:0,
no-multi-spaces:0,keyword-spacing:0,no-shadow:0,object-shorthand:0,global-require:0,no-inner-declarations:0 */
/* global AUTOBAHN_DEBUG:true */
function JSONSerializer(replacer, reviver) {
    this.replacer = replacer;
    this.reviver = reviver;
    this.SERIALIZER_ID = 'json';
    this.BINARY = false;
}

JSONSerializer.prototype.serialize = function (obj) {
    return JSON.stringify(obj, this.replacer);
};

JSONSerializer.prototype.unserialize = function (payload) {
    return JSON.parse(payload, this.reviver);
};

exports.JSONSerializer = JSONSerializer;

exports.MsgpackSerializer = null;



// WEBPACK FOOTER //
// ./src/lightweight-autobahn/src/serializer.js